<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i
          class="material-icons"
          id="menu-toggle"
          @click="isSidebar = !isSidebar"
          >view_headline</i
        >
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5" id="grad1">
          <!-- breadcrumb and title row starts -->
          <div class="row">
            <div class="col-sm-12">
              <vs-breadcrumb
                align="left"
                :items="[
                  { title: 'You are here : ' },
                  {
                    title: 'Dashboard',
                    url: '/#/dashboard/Advisor/advisordashboard'
                  },
                  {
                    title: 'Training Wizard',
                    url: '/#/dashboard/Advisor',
                   
                  },
                  {
                    title: ` ${updateTraining.title}`,
                    active: true,
                    class: 'font-bold'
                  }
                ]"
              ></vs-breadcrumb>
            </div>
            <div class="col-sm-12">
              <div class="heading mt-3">
                <h3 class="text-secondary">Training Wizard</h3>
              </div>
            </div>
          </div>
          <!-- breadcrumb and title row Ends -->
          <div class="row justify-content-center mt-0">
            <div class="col-11 text-center p-0 mt-3 mb-2">
              <div class="card px-0 pb-0 mt-3 mb-3">
                <!-- <h2>
                        <strong>Sign Up Your User Account</strong>
                    </h2>
                <p>Fill all form field to go to next step</p>-->
                <div class="row">
                  <div class="col-md-12 mx-0">
                    <form id="msform" @submit.prevent="updateAdvisorForm">
                      <!-- progressbar -->
                      <ul id="progressbar">
                        <li
                          title="Warning! You are not authorized to access."
                          id="NewTraining"
                        >
                          <strong>Training Assignment</strong>
                        </li>
                        <li
                          @click="advisorStep2Function()"
                          :class="{ 'active' : active == 2 }"
                          class="completed"
                          id="PoAssignment"
                        >
                          <strong>P.O Assignment</strong>
                        </li>
                        <li
                          @click="trainingInformation()"
                          :class="{ 'active' : active == 3 }"
                          id="TrainingInformation"
                        >
                          <strong>Event Information</strong>
                        </li>
                        <li
                          @click="trainerRegistration()"
                          :class="{ 'active' : active == 4 }"
                          id="TrainerRegistration"
                        >
                          <strong>Facilitators' Registration</strong>
                        </li>
                        <li
                          @click="trainingAgenda()"
                          :class="{ 'active' : active == 5 }"
                          id="TrainingAgenda"
                        >
                          <strong>Training Agenda</strong>
                        </li>
                        <li
                          @click="uploadMaterial()"
                          :class="{ 'active' : active == 6 }"
                          id="Trainingmaterial"
                        >
                          <strong>Upload Material</strong>
                        </li>
                        <li
                          @click="assessmentFunction()"
                          :class="{ 'active' : active == 7 }"
                          id="TrainingAssessments"
                        >
                          <strong>Assessments</strong>
                        </li>

                        <li
                          @click="traineeRegFunction()"
                          :class="{ 'active' : active == 8 }"
                          id="TraineeRegistration"
                        >
                          <strong>Participants' Registration</strong>
                        </li>
                        <li
                          @click="assessmentReviewFunction()"
                          :class="{ 'active' : active == 9 }"
                          id="AssessmentReview"
                        >
                          <strong>Assessment Review</strong>
                        </li>
                        <li
                          @click="trainingCompletionFunction()"
                          :class="{ 'active' : active == 10 }"
                          id="Completion"
                        >
                          <strong>Completion</strong>
                        </li>
                      </ul>
                      <!-- fieldsets -->
                      <fieldset
                        v-if="this.pageStep2 == true"
                        style="text-align: left;padding: 30px;"
                      >
                        <div class="row">
                          <div class="col">
                            <h5>
                              <span v-if="isClone">Copy </span>Training
                              Assignment
                            </h5>
                          </div>

                          <div class="col-auto">
                            <button
                              v-if="!isClone"
                              type="button"
                              class="btn btn-primary btn-sm m-1"
                              @click="cloneTraining"
                              id="clone_training"
                            >
                              Clone Training
                            </button>
                          </div>
                        </div>
                        <div class="clone-text" v-if="isClone">
                          Training has been cloned successfully, the
                          pre-assessment and post-assessment can now be enabled
                          under assessment review tab.
                        </div>

                        <!-- row 1 starts  -->
                        <div class="row mt-5">
                          <!--  col-md-6   -->
                          <div class="col-md-6">
                            <div class="form-group">
                              <label style="font-weight:700;" for="first"
                                >Training Title</label
                              >
                              <input
                                type="text"
                                class="form-control form-control-sm"
                                placeholder="Terrorism Investigation Course"
                                v-model="trainingTitle"
                                :disabled="!isClone"
                                id="training_title"
                              />
                            </div>
                          </div>

                          <div class="col-md-6">
                            <div class="form-group">
                              <label style="font-weight:700;">Project</label>
                              <selectize
                                id="select-state project"
                                v-model="project"
                                :disabled="programStatus"
                              >
                                <option
                                  v-for="(item, index) in projectsArray"
                                  :key="index"
                                  :value="item.id"
                                >
                                  {{ item.title }}
                                </option>
                              </selectize>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label style="font-weight:700;" for="first"
                                >Sub Programme</label
                              >
                              <select
                                style="opacity: 1 !important;background-color: #d3d3d3;"
                                class="form-control form-control-sm"
                                id="exampleFormControlSelect1 sub_program"
                                disabled
                              >
                                <option selected>{{ subprogram }}</option>
                              </select>
                            </div>
                          </div>

                          <div class="col-md-6">
                            <div class="form-group">
                              <label style="font-weight:700;" for="first"
                                >Assign Advisor</label
                              >
                              <select
                                style="opacity: 1 !important;background-color: #d3d3d3;"
                                class="form-control form-control-sm"
                                id="exampleFormControlSelect1 advisor"
                                disabled
                              >
                                <option selected>{{ advisor }}</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-6">
                            <label style="font-weight:700;" for="first"
                              >Select Program Officer
                              <span style="color:rgba(255, 0, 0, 0.78);"
                                >*</span
                              ></label
                            >

                            <selectize
                              id="select-state program_officer"
                              v-model="officerSelected"
                              :searchable="true"
                            >
                              <option
                                v-for="(item, index) in programOfficerAssign"
                                :key="index"
                                :value="item.id"
                              >
                                {{ item.name }}
                              </option>
                            </selectize>
                          </div>
                          <div class="col-md-6">
                            <label style="font-weight:700;" for="first"
                              >Training Topic</label
                            >
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              placeholder="Write Training Topic"
                              v-model="trainingTopic"
                              id="training_topic"
                            />
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-6">
                            <label style="font-weight:700;" for="first">
                              Thematic Area
                              <span style="color:rgba(255, 0, 0, 0.78);"
                                >*</span
                              >
                            </label>
                            <selectize
                              id="select-state thematic_area"
                              v-model="thematicareaSelectedUpdate"
                              :settings="thematicareasettings"
                            >
                              <option
                                v-for="(item, index) in valuesArray"
                                :key="index"
                                :value="item.id"
                              >
                                {{ item.name }}
                              </option>
                            </selectize>
                          </div>
                          <div class="col-md-6">
                            <label style="font-weight:700;">Donor Name</label>

                            <selectize
                              id="select-state doner_name"
                              v-model="fundingAgencySelected"
                              :settings="donersettings"
                            >
                              <option
                                v-for="(item, index) in donernameArr"
                                :key="index"
                                :value="item.id"
                              >
                                {{ item.title }}
                              </option>
                            </selectize>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-6">
                            <label style="font-weight:700;" for="first">
                              Select Date Range
                              <span style="color:rgba(255, 0, 0, 0.78);"
                                >*</span
                              >
                              <small class="text-info"
                                >(Note: To choose one day, double click on
                                specific date)</small
                              >
                            </label>
                            <flat-pickr
                              class="form-control"
                              style="background: #fff"
                              placeholder="Start date Range *"
                              v-model="dateRange"
                              :config="dateOptions"
                              id="select_date"
                            ></flat-pickr>
                          </div>
                          <div class="col-sm-6">
                            <div class="floating-label">
                              <label style="font-weight:700;" for="first">
                                No of days
                                <span style="color:rgba(255, 0, 0, 0.78);"
                                  >*</span
                                >
                              </label>
                              <input
                                disabled
                                class="floating-input form-control"
                                v-model="noOfDays"
                                type="text"
                                placeholder=" "
                              />

                              <span
                                class="lbl-label"
                                style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                              >
                                <i
                                  class="material-icons"
                                  style="font-size: 20px;"
                                  >event</i
                                >
                              </span>
                            </div>
                            <input type="hidden" v-model="update_training_id" />
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-6">
                            <label style="font-weight:700;" for="first"
                              >Training Outcome</label
                            >
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              v-model="outcome"
                              id="outcome"
                            />
                          </div>
                          <div class="col-md-6">
                            <label style="font-weight:700;" for="first"
                              >Training Output</label
                            >
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              v-model="output"
                              id="output"
                            />
                          </div>
                        </div>
                        <!-- Next Step Button Starts  -->
                        <div class="row">
                          <div class="col-md-12 text-right">
                            <router-link
                              to="/dashboard/Advisor/advisordashboard"
                              class="btn btn-primary btn-sm"
                              style="padding-top: 10px;"
                              >Back</router-link
                            >
                            &nbsp;
                            <b-button
                              type="submit"
                              class="btn btn-primary btn-sm"
                              variant="primary"
                              >Update</b-button
                            >
                            |
                            <button
                              type="button"
                              v-on:click="trainingInformation()"
                              class="btn btn-primary btn-sm m-1"
                              v-if="this.training_status == 'In Progress'"
                            >
                              Click to View Wizard >>
                            </button>
                            <button
                              type="button"
                              class="btn btn-primary btn-sm m-1"
                              disabled
                              title="Complete the above fields and update the training please."
                              v-else
                            >
                              Click to View Wizard >>
                            </button>
                          </div>
                        </div>

                        <!-- Next Step Button Ends  -->
                      </fieldset>
                      <fieldset
                        v-if="adminPage3 == true"
                        style="text-align: left;padding: 30px;"
                      >
                        <h5>Training Information</h5>
                        <!-- row 1 starts  -->
                        <div class="row mt-5">
                          <!--  col-md-6   -->
                          <div class="col-md-6">
                            <div class="form-group">
                              <label style="font-weight:700;" for="first"
                                >Training Title</label
                              >
                              <input
                                style="opacity: 1 !important;background-color: #d3d3d3;"
                                type="text"
                                class="form-control form-control-sm"
                                placeholder="Terrorism Investigation Course"
                                disabled
                                id="first"
                                :value="trainingTitle"
                              />
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label style="font-weight:700;" for="first"
                                >Sub Program</label
                              >
                              <input
                                style="opacity: 1 !important;background-color: #d3d3d3;"
                                type="text"
                                class="form-control form-control-sm"
                                placeholder="Terrorism Investigation Course"
                                disabled
                                id="first"
                                :value="updateTraining.subprogram.title"
                              />
                            </div>
                          </div>
                          <!--  col-md-6   -->
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label style="font-weight:700;" for="first"
                                >Project</label
                              >
                              <select
                                style="opacity: 1 !important;background-color: #d3d3d3;"
                                class="form-control form-control-sm"
                                id="exampleFormControlSelect1"
                                disabled
                              >
                                <option
                                  :value="updateTraining.project.id"
                                  selected
                                >
                                  {{updateTraining.project.title}}
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label style="font-weight:700;" for="first"
                                >Donor Name</label
                              >
                              <selectize
                                id="select-state"
                                disabled
                                v-model="donerSelected"
                                :settings="donersettings"
                              >
                                <option
                                  v-for="(item,index) in selectedDoner"
                                  :key="index"
                                  :value="item.id"
                                  disabled
                                >
                                  {{item.title}}
                                </option>
                              </selectize>
                            </div>
                          </div>
                        </div>
                        <!-- row 1 ends -->
                        <!-- row 2 starts  -->
                        <div class="row">
                          <!--  col-md-6   -->

                          <!--  col-md-6   -->
                          <div class="col-md-6">
                            <div class="form-group">
                              <label style="font-weight:700;" for="first"
                                >Department</label
                              >
                              <selectize
                                id="select-state"
                                v-model="department"
                                :settings="departmentsettings"
                                disabled
                              >
                                <option
                                  v-for="(item,index) in departmentArr"
                                  :key="index"
                                  :value="item.id"
                                >
                                  {{item.title}}
                                </option>
                              </selectize>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label style="font-weight:700;" for="first"
                                >Type</label
                              >
                              <selectize v-model="type_training" disabled>
                                <!-- settings is optional -->
                                <option
                                  v-for="(tType,index) in trainingTypeArr"
                                  :key="index"
                                  :value="tType.id"
                                >
                                  {{tType.title}}
                                </option>
                              </selectize>
                            </div>
                          </div>
                        </div>
                        <!-- row 2 ends -->
                        <!-- row 3 starts  -->
                        <div class="row">
                          <!--  col-md-6   -->

                          <!--  col-md-6   -->
                          <div class="col-md-6">
                            <div class="form-group">
                              <label style="font-weight:700;" for="first"
                                >Date Range</label
                              >
                              <flat-pickr
                                class="form-control"
                                style="background: #fff"
                                placeholder="Start date Range"
                                v-model="dateRange"
                                :config="dateOptions"
                                disabled
                              ></flat-pickr>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label style="font-weight:700;" for="first"
                                >Days</label
                              >
                              <input
                                class="floating-input form-control"
                                v-model="noOfDays"
                                type="text"
                                disabled
                                placeholder=" "
                              />
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-6">
                            <label style="font-weight:700;" for="first"
                              >Location</label
                            >
                            <selectize
                              id="select-state"
                              v-model="district"
                              disabled
                            >
                              <option
                                v-for="(item,index) in cityArr"
                                :key="index"
                                :value="item.id"
                              >
                                {{item.title}}, {{item.province.title}},
                                {{item.province.country.title}}
                              </option>
                            </selectize>
                          </div>
                          <div class="col-md-6">
                            <label style="font-weight:700;" for="first">
                              Contact Person
                              <span style="color:rgba(255, 0, 0, 0.78);"
                                >*</span
                              >
                            </label>
                            <input
                              class="floating-input form-control"
                              v-model="contact_person"
                              type="text"
                              placeholder=" "
                              disabled
                            />
                          </div>
                          <div
                            class="col-md-6 col-lg-6"
                            style="margin-top:10px;"
                          >
                            <div class="floating-label">
                              <input
                                class="floating-input form-control"
                                v-model="contact_number"
                                type="text"
                                v-mask="'(9999) 9999999'"
                                placeholder=" "
                                disabled
                              />
                              <span
                                class="lbl-label"
                                style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                              >
                                <i
                                  class="material-icons"
                                  style="font-size: 20px;"
                                  >call</i
                                >
                              </span>
                              <label class="lbl-label">
                                Contact Number
                                <span style="color:rgba(255, 0, 0, 0.78);"
                                  >*</span
                                >
                              </label>
                            </div>
                          </div>
                          <!-- email starts -->
                          <div class="col-md-6" style="margin-top:10px;">
                            <div class="floating-label">
                              <input
                                class="floating-input form-control"
                                v-model="contact_email"
                                type="email"
                                placeholder=" "
                                disabled
                              />

                              <span
                                class="lbl-label"
                                style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                              >
                                <i
                                  class="material-icons"
                                  style="font-size: 20px;"
                                  >email</i
                                >
                              </span>
                              <label class="lbl-label">
                                Email
                                <span style="color:rgba(255, 0, 0, 0.78);"
                                  >*</span
                                >
                              </label>
                            </div>
                          </div>
                          <!-- email ends -->
                          <!-- floating input ends -->
                        </div>
                        <div class="row">
                          <!-- floating input starts -->
                          <div class="col-md-6" style="margin-top:10px;">
                            <div class="floating-label">
                              <input
                                class="floating-input form-control"
                                v-model="address"
                                type="text"
                                placeholder=" "
                                disabled
                              />

                              <span
                                class="lbl-label"
                                style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                              >
                                <i
                                  class="material-icons"
                                  style="font-size: 20px;"
                                  >place</i
                                >
                              </span>
                              <label class="lbl-label">
                                Address
                                <span style="color:rgba(255, 0, 0, 0.78);"
                                  >*</span
                                >
                              </label>
                            </div>
                          </div>
                          <!-- floating input ends -->
                          <!-- Address Ends -->
                          <!-- floating input starts -->
                          <div
                            class="col-md-12 col-lg-12"
                            style="margin-top:10px;"
                          >
                            <div class="floating-label">
                              <input
                                class="floating-input form-control"
                                v-model="venue"
                                type="text"
                                placeholder=" "
                                disabled
                              />

                              <span
                                class="lbl-label"
                                style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                              >
                                <i
                                  class="material-icons"
                                  style="font-size: 20px;"
                                  >account_balance</i
                                >
                              </span>
                              <label class="lbl-label">
                                Venue
                                <span style="color:rgba(255, 0, 0, 0.78);"
                                  >*</span
                                >
                              </label>
                            </div>
                          </div>
                        </div>
                        <!-- Next Step Button Starts  -->
                        <div class="row">
                          <div class="col-md-12 text-right">
                            <button
                              type="button"
                              v-on:click="advisorStep2Function()"
                              class="btn btn-primary btn-sm m-1"
                            >
                              Back
                            </button>
                            <button
                              type="button"
                              v-on:click="trainerRegistration()"
                              class="btn btn-primary btn-sm m-1"
                            >
                              Next
                            </button>
                          </div>
                        </div>

                        <!-- Next Step Button Ends  -->
                      </fieldset>
                      <fieldset
                        v-if="adminPage4 == true"
                        style="text-align: left;padding: 30px;"
                      >
                        <vs-tabs class="custom-tabs" alignment="fixed">
                          <vs-tab label="Registered Trainer in this Training">
                            <div class="row mt-5">
                              <div class="table-responsive">
                                <div class="col-sm-12">
                                  <!-- new form popup starts -->
                                  <b-card>
                                    <div class="form-group">
                                      <div class="row">
                                        <div class="col-sm-12">
                                          <table class="table table-hover">
                                            <tr>
                                              <th>Sr#</th>
                                              <th>Name</th>
                                              <th>CNIC Number</th>
                                              <th>Passport</th>
                                              <th>Contact Number</th>
                                              <th>Email</th>
                                              <th>Password</th>
                                            </tr>

                                            <tr
                                              v-for="(item,
                                              index) in newTrainer"
                                              v-bind:key="item.trainer.id"
                                            >
                                              <td>{{ index + 1 }}</td>
                                              <td
                                                v-if="item.trainer.name != null"
                                                class="text-capitalize"
                                              >
                                                {{ item.trainer.name }}
                                              </td>
                                              <td v-else>--</td>
                                              <td
                                                v-if="item.trainer.cnic != null"
                                              >
                                                {{ item.trainer.cnic }}
                                              </td>
                                              <td v-else>--</td>
                                              <td
                                                v-if="
                                                  item.trainer.passport != null
                                                "
                                              >
                                                {{ item.trainer.passport }}
                                              </td>
                                              <td v-else>--</td>
                                              <td
                                                v-if="
                                                  item.trainer.mobile != null
                                                "
                                              >
                                                {{ item.trainer.mobile }}
                                              </td>
                                              <td v-else>--</td>
                                              <td
                                                v-if="
                                                  item.trainer.email != null
                                                "
                                              >
                                                {{ item.trainer.email }}
                                              </td>
                                              <td v-else>--</td>
                                              <td
                                                v-if="
                                                  item.trainer.trainer_user_id
                                                    .code != null
                                                "
                                              >
                                                {{
                                                item.trainer.trainer_user_id
                                                .code
                                                }}
                                              </td>
                                              <td v-else>--</td>
                                            </tr>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </b-card>
                                  <!-- new form popup ends -->
                                </div>
                              </div>
                            </div>
                          </vs-tab>
                        </vs-tabs>

                        <!-- row 1 starts  -->

                        <!-- Next Step Button Starts  -->
                        <div class="row">
                          <div class="col-md-12 text-right">
                            <button
                              type="button"
                              v-on:click="trainingInformation()"
                              class="btn btn-primary btn-sm m-1"
                            >
                              Back
                            </button>
                            <button
                              type="button"
                              v-on:click="trainingAgenda()"
                              class="btn btn-primary btn-sm"
                            >
                              Next
                            </button>
                          </div>
                        </div>

                        <!-- Next Step Button Ends  -->
                      </fieldset>
                      <fieldset
                        v-if="adminPage5 == true"
                        style="text-align: left;padding: 30px;"
                      >
                        <h5>Training Agenda</h5>

                        <!-- row 1 starts  -->
                        <div class>
                          <vs-tabs class="custom-tabs" alignment="left">
                            <template v-if="foundAgenda != ''">
                              <div class="col-sm-12 p-0 mt-3 new_design">
                                <b-card class="mt-3 new_design">
                                  <div class="form-group new_design">
                                    <div class="row new_design">
                                      <div class="col-sm-12 p-0">
                                        <div class="table-responsive">
                                          <table
                                            class="table"
                                            id="display"
                                            style="width:100%"
                                          >
                                            <tr>
                                              <th>Day</th>
                                              <th>Session #</th>
                                              <th>Title</th>
                                              <th>Assigned To</th>
                                              <th>Training Title</th>
                                              <th>Created At</th>
                                            </tr>
                                            <tbody>
                                              <tr
                                                v-for="(agenda,agendaIndex) in foundAgenda"
                                                :key="agendaIndex"
                                              >
                                                <td>{{agenda.days}}</td>
                                                <td class="text-capitalize">
                                                  {{agenda.session}}
                                                </td>
                                                <td class="text-capitalize">
                                                  {{agenda.title}}
                                                </td>
                                                <td
                                                  class="text-capitalize"
                                                  v-if="agenda.user != null"
                                                >
                                                  {{agenda.user.name}}
                                                </td>
                                                <td v-else>N/A</td>
                                                <td class="text-capitalize">
                                                  {{agenda.training.title}}
                                                </td>

                                                <td>
                                                  {{agenda.createdAt | formatDate}}
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                        <!-- </div> -->
                                      </div>
                                    </div>
                                  </div>
                                </b-card>
                                <!-- new form popup ends -->
                              </div>
                            </template>
                            <template v-else>
                              <span class="text-danger text-center"
                                >Agenda is not added yet.</span
                              >
                            </template>
                            <div class="row">
                              <div class="col-md-12 text-right">
                                <button
                                  type="button"
                                  v-on:click="trainerRegistration()"
                                  class="btn btn-primary btn-sm m-1"
                                >
                                  Back
                                </button>
                                <button
                                  type="button"
                                  v-on:click="uploadMaterial()"
                                  class="btn btn-primary btn-sm"
                                >
                                  Next
                                </button>
                              </div>
                            </div>
                          </vs-tabs>
                        </div>

                        <!-- Next Step Button Ends  -->
                      </fieldset>
                      <fieldset
                        v-if="adminPage6 == true"
                        style="text-align: left;padding: 30px;"
                      >
                        <h5>Uploaded Materials</h5>
                        <div class="form-group mt-2">
                          <div class="row">
                            <div class="col-sm-12">
                              <div class="table-responsive">
                                <table class="table table-stripped">
                                  <thead>
                                    <tr>
                                      <th>Title</th>
                                      <th>Upload Type</th>
                                      <th>File Type</th>
                                      <th>Download</th>
                                      <th>Created At</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr
                                      v-for="(material,index) in materialRecords"
                                      :key="index"
                                    >
                                      <td class="text-capitalize">
                                        {{material.title}}
                                      </td>
                                      <td class="text-capitalize">
                                        {{material.type}}
                                      </td>
                                      <td>{{material.fileType}}</td>
                                      <td v-if="material.uploadfile">
                                        <a
                                          :href="BASEPATHDYNAMIC+'/'+material.uploadfile"
                                          target="_blank"
                                        >
                                          <i
                                            class="material-icons"
                                            style="font-size:28px;color:#4285f4"
                                            >get_app</i
                                          >
                                        </a>
                                      </td>
                                      <td v-else>
                                        <a
                                          :href="material.link"
                                          target="_blank"
                                        >
                                          {{material.link}}
                                        </a>
                                      </td>
                                      <td>
                                        {{material.createdAt | formatDate}}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- Next Step Button Starts  -->
                        <div class="row">
                          <div class="col-md-12 text-right">
                            <button
                              type="button"
                              v-on:click="trainingAgenda()"
                              class="btn btn-primary btn-sm m-1"
                            >
                              Back
                            </button>
                            <button
                              type="button"
                              v-on:click="assessmentFunction()"
                              class="btn btn-primary btn-sm"
                            >
                              Next
                            </button>
                          </div>
                        </div>
                        <!-- Next Step Button Ends  -->
                      </fieldset>
                      <fieldset
                        v-if="adminPage7 == true"
                        style="text-align: left;padding: 30px;"
                      >
                        <h5>Training Assesment</h5>
                        <!-- row 1 starts  -->
                        <div class="row mt-5">
                          <vs-tabs class="custom-tabs">
                            <vs-tab label="Pre & Post">
                              <div class="row">
                                <div class="col-sm-12 mt-5">
                                  <!-- add assessments starts -->
                                  <div v-if="this.assessmentShowArr.length > 0">
                                    <h6 class="sub-frm-title">
                                      Pre & Post assessments have been created
                                      for this training.
                                    </h6>

                                    <div class="col-sm-12 mb-2 mt-3">
                                      <!-- nested row starts  -->
                                      <div class="row">
                                        <div class="col-sm-8">
                                          <h6 style="color:rgb(108, 117, 125);">
                                            Question Level Percentage
                                          </h6>
                                          <vs-row>
                                            <vs-col
                                              vs-type="flex"
                                              vs-align="center"
                                              vs-w="3"
                                            >
                                              <!-- chip starts  -->
                                              <div class="centerx">
                                                <vs-chip
                                                  color="success"
                                                  style="font-size:15px;"
                                                >
                                                  <Strong
                                                    style="font-size:15px; padding-right:5px;"
                                                    >B :</Strong
                                                  >
                                                  {{assessmentShowArr[0].easy_percent















                                                  }}%
                                                </vs-chip>
                                              </div>
                                              <!-- chip ends  -->
                                            </vs-col>
                                            <vs-col
                                              vs-type="flex"
                                              vs-align="center"
                                              vs-w="3"
                                            >
                                              <!-- chip starts  -->
                                              <div class="centerx">
                                                <vs-chip
                                                  color="warning"
                                                  style="font-size:15px;"
                                                >
                                                  <Strong
                                                    style="font-size:15px; padding-right:5px;"
                                                    >I :</Strong
                                                  >
                                                  {{assessmentShowArr[0].medium_percent















                                                  }}%
                                                </vs-chip>
                                              </div>
                                              <!-- chip ends  -->
                                            </vs-col>
                                            <vs-col
                                              vs-type="flex"
                                              vs-align="center"
                                              vs-w="3"
                                            >
                                              <!-- chip starts  -->
                                              <div class="centerx">
                                                <vs-chip
                                                  color="danger"
                                                  style="font-size:15px;"
                                                >
                                                  <Strong
                                                    style="font-size:15px; padding-right:5px;"
                                                    >A :</Strong
                                                  >
                                                  {{assessmentShowArr[0].hard_percent















                                                  }}%
                                                </vs-chip>
                                              </div>
                                              <!-- chip ends  -->
                                            </vs-col>
                                          </vs-row>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <!-- End of assessments -->

                                  <!-- if assessment exists -->
                                  <div
                                    class="table-responsive"
                                    v-if="assessmentShowArr.length > 0"
                                  >
                                    <table class="table table-hover">
                                      <tr>
                                        <th>Sr#</th>
                                        <th>Title</th>
                                        <th>Question Level</th>
                                        <th>Added at</th>
                                      </tr>
                                      <tr
                                        v-for="(item,index) in assessmentShowArr"
                                        v-bind:key="index"
                                      >
                                        <td>{{index+1}}</td>
                                        <td>{{item.question.title}}</td>
                                        <td v-if="item.question.level == 6">
                                          Basic
                                        </td>
                                        <td
                                          v-else-if="item.question.level == 7"
                                        >
                                          Intermediate
                                        </td>
                                        <td
                                          v-else-if="item.question.level == 8"
                                        >
                                          Advance
                                        </td>
                                        <td v-else>
                                          <code>N/A</code>
                                        </td>
                                        <td>{{item.createdAt | formatDate}}</td>
                                      </tr>
                                    </table>
                                  </div>
                                  <div v-else>
                                    <h6 class="sub-frm-title">
                                      Pre & Post assessments not found.
                                    </h6>
                                  </div>
                                  <!-- //If assessment exists -->
                                </div>
                              </div>
                            </vs-tab>
                            <vs-tab label="Trainer's Feedback">
                              <div class="row">
                                <div class="col-sm-12 mt-5">
                                  <!-- Trainer Feedback starts -->
                                  <div
                                    class="table-responsive"
                                    v-if="trainerFeedbackShowArr.length > 0"
                                  >
                                    <h6 class="sub-frm-title">
                                      Trainer's Feedback has been created for
                                      this training
                                    </h6>
                                    <table class="table table-hover">
                                      <tr>
                                        <th>Sr#</th>
                                        <th>Title</th>
                                        <th>Question Type</th>
                                        <th>Added at</th>
                                      </tr>
                                      <tr
                                        v-for="(item,index) in trainerFeedbackShowArr"
                                        v-bind:key="index"
                                      >
                                        <td>{{index+1}}</td>
                                        <td>{{item.question.title}}</td>
                                        <td v-if="item.type == 'mcqs'">
                                          MCQ's
                                        </td>
                                        <td
                                          v-else-if="item.type == 'descriptive'"
                                        >
                                          Descriptive
                                        </td>
                                        <td v-else>
                                          <code>NULL</code>
                                        </td>
                                        <td>{{item.createdAt | formatDate}}</td>
                                      </tr>
                                    </table>
                                  </div>
                                  <div v-else>
                                    <h6 class="sub-frm-title">
                                      Trainer feedback not found.
                                    </h6>
                                  </div>

                                  <!-- End of trainer feedback -->

                                  <!-- //trainer feedback exists -->
                                </div>
                              </div>
                            </vs-tab>
                            <vs-tab label="Trainee's Feedback">
                              <div class="row">
                                <div class="col-sm-12 mt-5">
                                  <!-- training question selection section starts -->
                                  <div
                                    class="table-responsive"
                                    v-if="traineeFeedbackShowArr.length > 0"
                                  >
                                    <h6 class="sub-frm-title">
                                      Trainee Feedback has been created for this
                                      training
                                    </h6>
                                    <!-- table starts -->
                                    <table class="table table-hover">
                                      <tr>
                                        <th>Sr#</th>
                                        <th>Title</th>
                                        <th>Added at</th>
                                      </tr>
                                      <tr
                                        v-for="(item,index) in traineeFeedbackShowArr"
                                        v-bind:key="index"
                                      >
                                        <td>{{index+1}}</td>
                                        <td>{{item.question.title}}</td>
                                        <td>{{item.createdAt | formatDate}}</td>
                                      </tr>
                                    </table>
                                  </div>
                                  <div v-else>
                                    <h6 class="sub-frm-title">
                                      Trainee feedback not found.
                                    </h6>
                                  </div>
                                  <!-- training question selection section ends -->
                                </div>
                              </div>
                            </vs-tab>
                          </vs-tabs>
                        </div>

                        <!-- Next Step Button Starts  -->
                        <div class="row">
                          <div class="col-md-12 text-right">
                            <button
                              type="button"
                              v-on:click="uploadMaterial()"
                              class="btn btn-primary btn-sm m-1"
                            >
                              Back
                            </button>
                            <button
                              type="button"
                              v-on:click="traineeRegFunction()"
                              class="btn btn-primary btn-sm"
                            >
                              Next
                            </button>
                          </div>
                        </div>

                        <!-- Next Step Button Ends  -->
                      </fieldset>

                      <fieldset
                        v-if="adminPage8 == true"
                        style="text-align: left;padding: 30px;"
                      >
                        <vs-tabs class="custom-tabs" alignment="fixed">
                          <h5>Registered Participants' in this Training</h5>
                          <div class="text-right mb-1 mr-1">
                            <button
                              type="button"
                              v-on:click="traineeRegFunction()"
                              class="btn btn-primary btn-sm"
                            >
                              <vs-icon icon="refresh" title="Refresh"></vs-icon>
                            </button>
                          </div>
                          <div class="row">
                            <div class="table-responsive">
                              <div class="col-sm-12">
                                <!-- new form popup starts -->
                                <div class="form-group">
                                  <div class="row">
                                    <div
                                      class="col-sm-12"
                                      v-if="this.itemsTrainee.length > 0"
                                    >
                                      <table class="table table-hover">
                                        <tr>
                                          <th>Sr#</th>
                                          <th>Name</th>
                                          <th>CNIC Number</th>
                                          <th>Passport</th>
                                          <th>Contact Number</th>
                                          <th>Username</th>
                                          <th>Password</th>
                                        </tr>

                                        <tr
                                          v-for="(item,
                                          index) in itemsTrainee"
                                          v-bind:key="item.id"
                                        >
                                          <td>{{ index + 1 }}</td>
                                          <td
                                            v-if="item.name != null"
                                            class="text-capitalize"
                                          >
                                            {{ item.name }}
                                          </td>
                                          <td v-else>NULL</td>
                                          <td v-if="item.cnic != null">
                                            {{ item.cnic }}
                                          </td>
                                          <td v-else>NULL</td>
                                          <td v-if="item.passportNo != null">
                                            {{ item.passportNo }}
                                          </td>
                                          <td v-else>NULL</td>
                                          <td v-if="item.contactNo != null">
                                            {{ item.contactNo }}
                                          </td>
                                          <td v-else>NULL</td>
                                          <td v-if="item.username != null">
                                            {{ item.username }}
                                          </td>
                                          <td v-else>NULL</td>
                                          <td v-if="item.code != null">
                                            {{ item.code }}
                                          </td>
                                          <td v-else>N/A</td>
                                        </tr>
                                      </table>
                                    </div>
                                    <div class="col-sm-12" v-else>
                                      <table class="table table-hover">
                                        <tr>
                                          <th>Sr#</th>
                                          <th>Name</th>
                                          <th>CNIC Number</th>
                                          <th>Passport</th>
                                          <th>Contact Number</th>
                                          <th>Email</th>
                                          <th>Password</th>
                                        </tr>
                                      </table>
                                      <span>No trainee registered yet.</span>
                                    </div>
                                  </div>
                                </div>
                                <!-- new form popup ends -->
                              </div>
                            </div>
                          </div>
                        </vs-tabs>

                        <!-- row 1 starts  -->

                        <!-- Next Step Button Starts  -->
                        <div class="row">
                          <div class="col-md-12 text-right">
                            <button
                              type="button"
                              v-on:click="assessmentFunction()"
                              class="btn btn-primary btn-sm m-1"
                            >
                              Back
                            </button>
                            <button
                              type="button"
                              v-on:click="assessmentReviewFunction()"
                              class="btn btn-primary btn-sm"
                            >
                              Next
                            </button>
                          </div>
                        </div>

                        <!-- Next Step Button Ends  -->
                      </fieldset>
                      <fieldset
                        v-if="adminPage9 == true"
                        style="text-align: left;padding: 30px;"
                      >
                        <h5>Training Assessment Execution</h5>
                        <div class="text-right mb-1">
                          <button
                            type="button"
                            v-on:click="assessmentReviewFunction()"
                            class="btn btn-primary btn-sm"
                          >
                            <vs-icon icon="refresh" title="Refresh"></vs-icon>
                          </button>
                        </div>
                        <!-- row 1 starts  -->
                        <div class="row">
                          <div class="table-responsive">
                            <div class="col-sm-12">
                              <!-- new form popup starts -->
                              <div class="form-group">
                                <div class="row">
                                  <div class="col-sm-12">
                                    <table class="table table-hover">
                                      <tr>
                                        <th>Sr#</th>
                                        <th>Name</th>
                                        <th>CNIC Number</th>
                                        <th>Contact Number</th>
                                        <th>Username</th>
                                        <th>Pre</th>
                                        <th>Post</th>
                                      </tr>

                                      <tr
                                        v-for="(item, index) in itemsTraineeReview"
                                        v-bind:key="item.id"
                                      >
                                        <td>{{index+1}}</td>
                                        <td
                                          v-if="item.name != null"
                                          class="text-capitalize"
                                        >
                                          {{item.name}}
                                        </td>
                                        <td v-else>NULL</td>
                                        <td v-if="item.cnic != null">
                                          {{item.cnic}}
                                        </td>
                                        <td v-else>NULL</td>
                                        <td v-if="item.contactNo != null">
                                          {{item.contactNo}}
                                        </td>
                                        <td v-else>NULL</td>
                                        <td v-if="item.username != null">
                                          {{item.username}}
                                        </td>
                                        <td v-else>NULL</td>
                                        <td
                                          v-if="item.preassesmentcheck =='found'"
                                        >
                                          <span>
                                            <vs-icon
                                              class="mr-1"
                                              icon="check"
                                              style="color:#007bff;font-size:20px;font-weight:600;cursor: pointer;"
                                              title="Pre Assessment done"
                                            ></vs-icon>
                                          </span>
                                        </td>
                                        <td v-else>
                                          <vs-icon
                                            class="mr-1"
                                            icon="close"
                                            style="color:#ff0000c7;font-size:20px;font-weight:600;cursor: pointer;"
                                            title="Pre Assessment not done"
                                          ></vs-icon>
                                        </td>
                                        <td
                                          v-if="item.postassesmentcheck =='found'"
                                        >
                                          <span>
                                            <vs-icon
                                              class="mr-1"
                                              icon="check"
                                              style="color:#007bff;font-size:20px;font-weight:600;cursor: pointer;"
                                              title="Post Assessment done"
                                            ></vs-icon>
                                          </span>
                                        </td>
                                        <td v-else>
                                          <vs-icon
                                            class="mr-1"
                                            icon="close"
                                            style="color:#ff0000c7;font-size:20px;font-weight:600;cursor: pointer;"
                                            title="Post Assessment not done"
                                          ></vs-icon>
                                        </td>
                                      </tr>
                                    </table>
                                  </div>
                                </div>
                              </div>
                              <!-- new form popup ends -->
                            </div>
                          </div>
                        </div>

                        <!-- Next Step Button Starts  -->
                        <div class="row">
                          <div class="col-md-12 text-right">
                            <button
                              type="button"
                              v-on:click="traineeRegFunction()"
                              class="btn btn-primary btn-sm m-1"
                            >
                              Back
                            </button>
                            <button
                              type="button"
                              v-on:click="trainingCompletionFunction()"
                              class="btn btn-primary btn-sm"
                            >
                              Next
                            </button>
                          </div>
                        </div>
                        <!-- Next Step Button Ends  -->
                      </fieldset>

                      <fieldset
                        v-if="adminPage10 == true"
                        style="text-align: left;padding: 30px; min-height: 300px"
                      >
                        <span
                          v-if="this.training_status_check.preassesment_status == 1 && this.training_status_check.postassesment_status == 1"
                        >
                          <h5 class="text-center text-success mt-5">
                            <i class="material-icons">check</i> This Training
                            has been Completed Successfully
                          </h5>
                        </span>
                        <span class="mt-3" v-else>
                          <h5 class="text-center text-danger">
                            Warning! This Training is not completed and still
                            In-Progress
                          </h5>
                          <hr />
                          <li
                            class="text-success"
                            v-if="this.training_status_check.preassesment_status == 1"
                          >
                            <i class="material-icons">check</i> Pre Assessment
                            is enabled and being completed.
                          </li>
                          <li v-else class="text-danger">
                            <i class="material-icons">close</i> Pre Assessment
                            is not enabled yet.
                          </li>
                          <li
                            class="text-success"
                            v-if="this.training_status_check.postassesment_status == 1"
                          >
                            <i class="material-icons">check</i> Post Assessment
                            is enabled and being completed.
                          </li>
                          <li v-else class="text-danger">
                            <i class="material-icons">close</i> Post Assessment
                            is not enabled yet.
                          </li>
                          <li
                            class="text-success"
                            v-if="this.training_status_check.feedbackstatus == 1"
                          >
                            <i class="material-icons">check</i> Feedback is
                            enabled and being completed.
                          </li>
                          <li v-else class="text-danger">
                            <i class="material-icons">close</i> Feedback is not
                            enabled yet.
                          </li>
                          <hr />
                        </span>
                        <!-- row 1 starts  -->
                        <div
                          class="row mt-5 mb-1 d-flex justify-content-center"
                        >
                          <button class="btn btn-primary float-right ml-3">
                            <router-link
                              :to="{
                                path:
                                  '/dashboard/advisor/brief_training_report',
                                query: { trainingId: this.trainingCode }
                              }"
                              class="white-text"
                              >Brief Training Details</router-link
                            >
                          </button>
                          <button class="btn btn-primary float-right ml-3">
                            <router-link
                              :to="{
                                path: '/dashboard/advisor/analysis-report',
                                query: { trainingId: this.trainingCode }
                              }"
                              class="white-text"
                              >Overall Training Analysis</router-link
                            >
                          </button>

                          <button class="btn btn-primary float-right ml-3">
                            <router-link
                              :to="{
                                path:
                                  '/dashboard/advisor/individual_analysis_report',
                                query: { trainingId: this.trainingCode }
                              }"
                              class="white-text"
                              >Individual Training Analysis</router-link
                            >
                          </button>
                          <button class="btn btn-primary float-right ml-3">
                            <div @click="getReport1">
                              Download Training Report
                            </div>
                          </button>
                        </div>
                      </fieldset>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Selectize from "vue2-selectize";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import axios from "axios";
import {
    downloadTrainingReport
} from '../../../utils/DownloadReport';

export default {
    data: () => ({
        trainingTopic: "",
        programStatus: false,
        projectsArray: [],
        project: "",
        trainingTitle: "",
        isClone: false,
        isSidebar: false,
        trainingId: "",
        trainingCode: "",
        updateTraining: [],
        officerSelected: "",
        update_training_id: "",
        outcome:"",
        output:"",
        dateRange: [],
        dateOptions: {
            wrap: true,
            weekNumbers: true,
            mode: "range",
            // maxDate: new Date().fp_incr(9),
            dateFormat: "d-m-Y"
        },
        fundingAgencySelected: [],
        donersettings: {
            maxItems: 5,
            plugins: ["remove_button"],
            delimiter: "|"
        },
        donernameArr: [],
        thematicareaSelectedUpdate: [],
        thematicareasettings: {
            maxItems: 10,
            plugins: ["remove_button"],
            delimiter: "|"
        },
        startdate: "",
        startDate: "",
        endDate: "",
        programOfficerAssign: [],
        advisor: "",
        subprogram: "",
        enddate: "",
        valuesArray: [],
        noOfDays: "",
        isDataEdit: 0,

        departmentsettings: {
            maxItems: 10,
            plugins: ["remove_button"],
            delimiter: "|"
        },
        departmentArr: [],
        department: [],
        trainingTypeArr: [],
        countryArr: [],
        provinceArr: [],
        cityArr: [],
        contact_number: "",
        contact_email: "",
        contact_person: "",
        type_training: "",
        district: "",
        textarea: "",
        address: "",
        venue: "",
        donerSelected: [],
        selectedDoner: [],
        newTrainer: [],
        foundAgenda: [],
        materialRecords: [],

        // pre & post assessments
        existPreassessmentForm: false,
        showAssessmentTable: false,
        easyPercent: 0,
        mediumPercent: 0,
        hardPercent: 0,
        assessmentShowArr: [],
        // End of pre & post
        // Starts of Trainer feedback
        existTrainerFeedbackForm: false,
        trainerFeedbackShowArr: [],
        // End of Trainer feedback

        // Trainee
        traineeFeedbackShowArr: [],
        existTraineeFeedForm: false,
        // End of Trainee
        itemsTrainee: [],
        itemsTraineeReview: [],
        training_status: "",
        training_status_check: "",
        active: 2,
        pageStep2: true,
        adminPage3: false,
        adminPage4: false,
        adminPage5: false,
        adminPage6: false,
        adminPage7: false,
        adminPage8: false,
        adminPage9: false,
        adminPage10: false,
         BASEPATHDYNAMIC: "",

    }),
    created() {
       this.BASEPATHDYNAMIC = localStorage.getItem("BASE_PATH");
        this.trainingCode = this.$route.query.trainingId;
        if (this.$route.query.clone === 'true') {
            this.isClone = true;
        }
        this.openLoading();
        axios
            .get(localStorage.getItem("BASE_PATH") + "/projects/get")
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.projectsArray = response.data;
            });
        axios
            .get(
                localStorage.getItem("BASE_PATH") +
                "/training/advisor/" +
                this.$route.query.trainingId +
                "/edit"

            )
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                if (response) {
                    this.trainingId = response.data.training.id;
                    this.training_status = response.data.training.trainingstatus;
                    this.training_status_check = response.data.training;
                    this.thematicareaSelectedUpdate = [];
                    //this.fundingAgencySelected = [];
                    this.officerSelected = [];
                    // this.freqUpdateArr =[];
                    response.data.thematic.forEach(dnr => {
                        this.thematicareaSelectedUpdate.push(dnr.id);
                    });
                    response.data.fundingagency.forEach(dnr => {
                        //this.fundingAgencySelected.push(dnr.id);
                    });
                    response.data.officer.forEach(dnr => {
                        this.officerSelected.push(dnr.id);
                    });
                    if (
                        response.data.training != "" &&
                        response.data.training.TrainingDates != undefined &&
                        response.data.training.TrainingDates != ""
                    ) {
                        JSON.parse(response.data.training.TrainingDates).forEach(
                            element => {
                                if (
                                    element.startDate != undefined &&
                                    element.endDate != undefined &&
                                    element.endDate != "" &&
                                    element.startDate != ""
                                ) {
                                    this.freqUpdateArr.push({
                                        startDate: element.startDate,
                                        endDate: element.endDate
                                    });
                                }
                            }
                        );
                    }

                    this.noOfDays = response.data.training.noofdays;
                    this.freqLimit = response.data.training.frequency;
                }
            });
    },
    mounted() {
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        // step 2
        this.advisorStep2Function();
        this.openLoading();
        axios
            .get(localStorage.getItem("BASE_PATH") + "/programofficer/get")
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.programOfficerAssign = response.data;
            });
        this.openLoading();
        axios
            .get(localStorage.getItem("BASE_PATH") + "/donernames/get")
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.donernameArr = response.data;
            });
        this.openLoading();
        axios
            .get(localStorage.getItem("BASE_PATH") + "/thematics/get")
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.valuesArray = response.data;
            });
    },
    methods: {
        // step 2
        advisorStep2Function() {
            this.pageStep2 = true;
            this.adminPage3 = true;
            this.adminPage4 = false;
            this.adminPage5 = false;
            this.adminPage6 = false;
            this.adminPage7 = false;
            this.adminPage8 = false;
            this.adminPage9 = false;
            this.adminPage10 = false;
            this.active = 2;
            this.openLoading();
            axios
                .get(
                    localStorage.getItem("BASE_PATH") +
                    "/advisor/trainingsingle/get/" +
                    this.trainingCode

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.trainingTopic = response?.data?.training?.trainingTopic ?? '',
                    this.updateTraining = response?.data?.training ?? '';
                    this.update_training_id = response?.data?.training?.id ?? '';
                    this.trainingTitle = response?.data?.training?.title ?? '';
                    this.outcome = response?.data?.training?.outcome ?? '';
                    this.output = response?.data?.training?.output ?? '';
                    if (response.data.training.postassesment_status == true && response.data.training.preassesment_status == true) {
                        this.programStatus = true
                    }
                    if (response.data.training.project != undefined) {
                        this.project = response.data.training.project.id;
                    }
                    if (response.data.training.subprogram) {
                        this.subprogram = response.data.training.subprogram.title;
                    }
                    if (response.data.training.advisor) {
                        this.advisor = response.data.training.advisor.name;
                    }
                    if (response.data && response.data.selectedDonors) {
                        this.fundingAgencySelected = [];
                        response.data.selectedDonors.forEach(dnr => {
                            //alert(dnr.id);
                            this.fundingAgencySelected.push(dnr.id);
                        });
                    }
                    this.dateRange =
                        response.data.training.startdate + " to " + response.data.training.enddate;
                });
        },

        // step 3
        trainingInformation() {
            this.pageStep2 = false;
            this.adminPage3 = true;
            this.adminPage4 = false;
            this.adminPage5 = false;
            this.adminPage6 = false;
            this.adminPage7 = false;
            this.adminPage8 = false;
            this.adminPage9 = false;
            this.adminPage10 = false;
            this.active = 3;
            this.openLoading();
            axios
                .get(
                    localStorage.getItem("BASE_PATH") +
                    "/programOfficer/trainingsingle/get/" +
                    this.trainingCode

                )
                .then(async response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    await this.adminCountry();
                    await this.adminProvince();
                    await this.adminDistricts();
                    await this.adminDepartment();
                    await this.adminTrainingType();
                    if (response.data && response.data.doner != undefined) {
                        this.selectedDoner = response.data.doner;
                    }
                    response.data.doner.forEach(dnr => {
                        this.donerSelected.push(dnr.id);
                    });
                    if (response.data.training.typetraining_id != null) {
                        this.type_training = response.data.training.typetraining_id;
                    }
                    if (
                        response.data.training != undefined &&
                        response.data.training != null &&
                        response.data.training.noofdays
                    ) {
                        this.noOfDays = response.data.training.noofdays;
                    }
                    if (
                        response.data.training.startdate != null &&
                        response.data.training.enddate != null
                    ) {
                        this.dateRange =
                            response.data.training.startdate +
                            " to " +
                            response.data.training.enddate;
                    }
                    if (response.data.training.district_id != null) {
                        this.district = response.data.training.district_id;
                    }
                    if (response.data.training.contact_person != null) {
                        this.contact_person = response.data.training.contact_person;
                    }
                    if (response.data.training.contact_number != null) {
                        this.contact_number = response.data.training.contact_number;
                    }
                    if (response.data.training.email != null) {
                        this.contact_email = response.data.training.email;
                    }
                    if (response.data.training.address != null) {
                        this.address = response.data.training.address;
                    }
                    if (response.data.training.venue != null) {
                        this.venue = response.data.training.venue;
                    }

                    if (response.data.departments && response.data.departments != "") {
                        response.data.departments.forEach(department => {
                            this.department.push(department.id);
                        });
                    }
                    // this.type_training = response.data.trainingtype.title;
                });
        },
        // step 4
        trainerRegistration() {
            this.pageStep2 = false;
            this.adminPage3 = false;
            this.adminPage4 = true;
            this.adminPage5 = false;
            this.adminPage6 = false;
            this.adminPage7 = false;
            this.adminPage8 = false;
            this.adminPage9 = false;
            this.adminPage10 = false;
            this.active = 4;
            this.newTrainer = [];
            this.openLoading();
            axios
                .get(
                    localStorage.getItem("BASE_PATH") +
                    "/trainer/show/training/" +
                    this.trainingId

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    if (response.data != null)
                        this.newTrainer = response.data;
                });
        },
        // step 5
        trainingAgenda() {
            this.pageStep2 = false;
            this.adminPage3 = false;
            this.adminPage4 = false;
            this.adminPage5 = true;
            this.adminPage6 = false;
            this.adminPage7 = false;
            this.adminPage8 = false;
            this.adminPage9 = false;
            this.adminPage10 = false;
            this.active = 5;
            this.openLoading();
            axios
                .get(
                    localStorage.getItem("BASE_PATH") +
                    "/check/traninig/agenda/" +
                    this.trainingId

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    if (response.data && response.data.foundagenda != null) {
                        this.foundAgenda = response.data.foundagenda;
                    } else {
                        this.foundAgenda = [];
                    }
                });
        },
        // step 6
        uploadMaterial() {
            this.pageStep2 = false;
            this.adminPage3 = false;
            this.adminPage4 = false;
            this.adminPage5 = false;
            this.adminPage6 = true;
            this.adminPage7 = false;
            this.adminPage8 = false;
            this.adminPage9 = false;
            this.adminPage10 = false;
            this.active = 6;
            this.openLoading();
            axios
                .get(
                    localStorage.getItem("BASE_PATH") +
                    "/admin/training_material/get/" + this.trainingId

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    if (response.data.materials) {
                        this.materialRecords = response.data.materials;
                    }
                });
        },
        // step 7
        assessmentFunction() {
            this.pageStep2 = false;
            this.adminPage3 = false;
            this.adminPage4 = false;
            this.adminPage5 = false;
            this.adminPage6 = false;
            this.adminPage7 = true;
            this.adminPage8 = false;
            this.adminPage9 = false;
            this.adminPage10 = false;
            this.active = 7;
            this.showAssessment();
            this.showTraineeFeedback();
            this.showTrainerFeedback();
        },
        // step 8
        traineeRegFunction() {
            this.pageStep2 = false;
            this.adminPage3 = false;
            this.adminPage4 = false;
            this.adminPage5 = false;
            this.adminPage6 = false;
            this.adminPage7 = false;
            this.adminPage8 = true;
            this.adminPage9 = false;
            this.adminPage10 = false;
            this.active = 8;
            this.openLoading();
            axios
                .get(
                    localStorage.getItem("BASE_PATH") + "/trainee/show/" + this.trainingId

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.itemsTrainee = response.data;
                });
        },
        // step 9
        assessmentReviewFunction() {
            this.pageStep2 = false;
            this.adminPage3 = false;
            this.adminPage4 = false;
            this.adminPage5 = false;
            this.adminPage6 = false;
            this.adminPage7 = false;
            this.adminPage8 = false;
            this.adminPage9 = true;
            this.adminPage10 = false;
            this.active = 9;
            this.openLoading();
            axios
                .get(
                    localStorage.getItem("BASE_PATH") + "/trainee/show/" + this.trainingId

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.itemsTraineeReview = response.data;
                });
        },
        // step 10 completion
        trainingCompletionFunction() {
            this.pageStep2 = false;
            this.adminPage3 = false;
            this.adminPage4 = false;
            this.adminPage5 = false;
            this.adminPage6 = false;
            this.adminPage7 = false;
            this.adminPage8 = false;
            this.adminPage9 = false;
            this.adminPage10 = true;
            this.active = 10;
        },
        // this will show assessment which has been added
        showAssessment: function showAssessment() {
            this.openLoading();
            axios
                .get(
                    localStorage.getItem("BASE_PATH") +
                    "/program-officer/training/assessment/" +
                    this.trainingId +
                    "/show"

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.assessmentShowArr = response.data;
                    this.showAssessmentTable = true;
                });
        },
        // this will show trainee feedback which has been added
        showTraineeFeedback: function showTraineeFeedback() {
            this.openLoading();
            axios
                .get(
                    localStorage.getItem("BASE_PATH") +
                    "/program-officer/training/trainee-feedback/" +
                    this.trainingId +
                    "/show"

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.traineeFeedbackShowArr = response.data;
                });
        },
        // this will show trainer feedback which has been added
        showTrainerFeedback: function showTrainerFeedback() {
            this.openLoading();
            axios
                .get(
                    localStorage.getItem("BASE_PATH") +
                    "/program-officer/training/trainer-feedback/" +
                    this.trainingId +
                    "/show"

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.trainerFeedbackShowArr = response.data;
                });
        },

        // step 3 functions
        adminCountry() {
            this.openLoading();
            axios
                .get(localStorage.getItem("BASE_PATH") + "/countries/get")
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.countryArr = response.data;
                });
        },
        //select all provinces
        adminProvince() {
            this.openLoading();
            axios
                .get(localStorage.getItem("BASE_PATH") + "/provinces/get")
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.provinceArr = response.data;
                });
        },
        //select all district
        adminDistricts() {
            this.openLoading();
            axios
                .get(localStorage.getItem("BASE_PATH") + "/districts/get")
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.cityArr = response.data;
                });
        },
        //select all department
        adminDepartment() {
            this.openLoading();
            axios
                .get(localStorage.getItem("BASE_PATH") + "/departments/get")
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.departmentArr = response.data;
                });
        },
        //select all training type
        adminTrainingType() {
            this.openLoading();
            axios
                .get(localStorage.getItem("BASE_PATH") + "/trainingtype/get")
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.trainingTypeArr = response.data;
                });
        },

        // Clone Training
        cloneTraining() {
            this.openLoading();

            // Step 2: Make API call to get training details
            axios
                .get(localStorage.getItem("BASE_PATH") + "/training/get/" + this.trainingId)
                .then(response => {
                    const trainingCode = response.data.training_code;
                    this.closeLoading();
                    this.$router.push({
                        path: '/dashboard/advisor/training-Assignment',
                        query: {
                            trainingId: trainingCode,
                            clone: true
                        }
                    });
                    window.location.reload();
                })
                .catch(error => {
                    console.error("Error cloning training:", error);
                    this.closeLoading();
                });

        },
        // End of step 3

        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
        printReport: function () {
            window.print();
        },
        toastSuccess(msg) {
            this.$bvToast.toast(msg, {
                title: "Success",
                autoHideDelay: 10000,
                variant: "success",
                solid: true
            });
        },
        toastError(msg) {
            this.$bvToast.toast(msg, {
                title: "Error",
                autoHideDelay: 10000,
                variant: "danger",
                solid: true
            });
        },
        updateAdvisorForm(e) {
            e.preventDefault();
            this.inValid = [];
            if (
                this.thematicareaSelectedUpdate == "" ||
                this.thematicareaSelectedUpdate.length == 0
            ) {
                this.inValid.push("Please select Thematic Area.");
            }
            if (
                this.fundingAgencySelected == "" ||
                this.fundingAgencySelected.length == 0
            ) {
                this.inValid.push("Please Select Donor.");
            }
            if (this.officerSelected == "" || this.officerSelected.length == 0) {
                this.inValid.push("Please Select Assign To.");
            }
            if (this.noOfDays == "" || this.noOfDays.length == 0) {
                this.inValid.push("Please enter number of days.");
            }

            for (var i = 0; i < this.inValid.length; i++) {
                this.$toasted.global.errorMsg(this.inValid[i]);
            }
            let self = this;
            if (!this.inValid.length) {
                this.openLoading();
                axios
                    .post(
                        localStorage.getItem("BASE_PATH") + "/advisor/update/training", {
                            user_id: JSON.parse(localStorage.getItem("currentUser")).id,
                            doner: JSON.stringify(this.fundingAgencySelected),
                            trainingId: this.trainingCode,
                            thematic: JSON.stringify(this.thematicareaSelectedUpdate),
                            assign: this.officerSelected,
                            noofdays: this.noOfDays,
                            frequence: this.freqLimit,
                            startDate: this.startDate,
                            endDate: this.endDate,
                            trainingTitle: this.trainingTitle,
                            project: this.project,
                            trainingTopic: this.trainingTopic,
                            output : this.output,
                            outcome : this.outcome,
                            description: "",
                        }
                    )
                    .then(response => {
                        this.closeLoading();
                        if (response.data.success) {
                            self.toastSuccess("Record has been updated successfully!");
                            self.advisorStep2Function();
                        } else {
                            self.toastError("Something went wrong. Try again please!");
                        }
                    })
                    .catch(error => {
                        self.toastError(error);
                    });
            }
        },
        getReport1() {
            downloadTrainingReport(this.trainingCode)
        },

    },
    watch: {
        dateRange(date) {
            this.startDate = date.split(" to")[0];
            this.endDate = date.split("to ")[1];
            this.isDataEdit++;
            if (this.isDataEdit > 1) {
                let daysLengthTotal;
                this.startDate = date.split(" to")[0];
                this.endDate = date.split("to ")[1];
                if (date.includes("to")) {
                    let daysInRange = document.getElementsByClassName("inRange");
                    if (this.startDate.split("-")[1] == this.endDate.split("-")[1]) {
                        daysLengthTotal = daysInRange.length + 2;
                    } else {
                        daysLengthTotal = daysInRange.length + 2;
                    }
                    this.noOfDays = daysLengthTotal;
                } else if (!date.includes("to") && date != "") {
                    this.startDate = date;
                    this.endDate = date;
                    this.noOfDays = 1;
                } else {
                    this.startDate = "";
                    this.endDate = "";
                    this.noOfDays = "";
                }
            }
        }
    },
    components: {
        Selectize,
        flatPickr,
        "app-navbar": Navbar,
        "app-sidebar": Sidebar
    }
};
</script>

<style scoped>
.vs-breadcrumb {
  font-size: 18px !important;
  font-weight: 600 !important;
}
.btn-primary {
  font-size: 14px;
  height: 44px;
  background: #06a6e0;
  color: #ffffff;
  font-weight: 500;
  border-radius: 5px
}
.white-text {
  color: #ffffff;
}
.btn-primary:hover {
  background: #08769e;
}

#grad1 {
    background-color: #fff;
}

#msform {
    text-align: center;
    position: relative;
    margin-top: 20px;
}

#msform fieldset .form-card {
    background: white;
    border: 0 none;
    border-radius: 0px;
    box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2);
    padding: 20px 40px 30px 40px;
    box-sizing: border-box;
    width: 94%;
    margin: 0 3% 20px 3%;
    position: relative;
}

#msform fieldset {
    padding: 10px;
    background: #e8e8e8;
    border: 0 none;
    border-radius: 2rem;
    box-sizing: border-box;
    width: 100%;
    margin: 0;
    border: 2px solid #ccc;
    padding-bottom: 20px;
    position: relative;
}

#msform fieldset:not(:first-of-type) {
    display: none;
}

#msform fieldset .form-card {
    text-align: left;
    color: #9e9e9e;
}

#progressbar .completed {
    color: #06a6e0;
}

#progressbar li.completed:before,
#progressbar li.completed:after {
    background: #06a6e0;
}

#msform .action-button {
    width: 100px;
    background: skyblue;
    font-weight: bold;
    color: white;
    border: 0 none;
    border-radius: 0px;
    cursor: pointer;
    padding: 10px 5px;
    margin: 10px 5px;
}

#msform .action-button:hover,
#msform .action-button:focus {
    box-shadow: 0 0 0 2px white, 0 0 0 3px skyblue;
}

#msform .action-button-previous {
    width: 100px;
    background: #616161;
    font-weight: bold;
    color: white;
    border: 0 none;
    border-radius: 0px;
    cursor: pointer;
    padding: 10px 5px;
    margin: 10px 5px;
}

#msform .action-button-previous:hover,
#msform .action-button-previous:focus {
    box-shadow: 0 0 0 2px white, 0 0 0 3px #616161;
}

select.list-dt {
    border: none;
    outline: 0;
    border-bottom: 1px solid #ccc;
    padding: 2px 5px 3px 5px;
    margin: 2px;
}

select.list-dt:focus {
    border-bottom: 2px solid skyblue;
}

.card {
    z-index: 0;
    border: none;
    border-radius: 0.5rem;
    position: relative;
}

.fs-title {
    font-size: 25px;
    color: #2c3e50;
    margin-bottom: 10px;
    font-weight: bold;
    text-align: left;
}

#progressbar {
    margin-bottom: 30px;
    overflow: hidden;
    color: lightgrey;
}

#progressbar .active {
    color: #000000;
}

#progressbar li {
    list-style-type: none;
    font-size: 12px;
    width: 9.5%;
    text-align: center;
    float: left;
    position: relative;
}

#progressbar #NewTraining:before {
    content: "1";
}

#progressbar #PoAssignment:before {
    content: "2";
}

#progressbar #TrainingInformation:before {
    content: "3";
}

#progressbar #TrainerRegistration:before {
    content: "4a";
}

#progressbar #TrainingAgenda:before {
    content: "4b";
}

#progressbar #Trainingmaterial:before {
    content: "4c";
}

#progressbar #TrainingAssessments:before {
    content: "4d";
}

#progressbar #TraineeRegistration:before {
    content: "4e";
}

#progressbar #AssessmentReview:before {
    content: "5";
}

#progressbar #Completion:before {
    content: "6";
}

#progressbar li:before {
    width: 35px;
    height: 35px;
    line-height: 30px;
    display: block;
    font-size: 18px;
    color: #ffffff;
    background: lightgray;
    border-radius: 50%;
    margin: 0 auto 10px auto;
    padding: 2px;
}

#progressbar li:after {
    content: "";
    width: 100%;
    height: 2px;
    background: lightgray;
    position: absolute;
    left: 0;
    top: 17px;
    z-index: -1;
}

#progressbar li.active:before,
#progressbar li.active:after {
    background: #000000;
}

.radio-group {
    position: relative;
    margin-bottom: 25px;
}

.radio {
    display: inline-block;
    width: 204;
    height: 104;
    border-radius: 0;
    background: lightblue;
    box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    cursor: pointer;
    margin: 8px 2px;
}

.radio:hover {
    box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.3);
}

.radio.selected {
    box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.1);
}

.fit-image {
    width: 100%;
    object-fit: cover;
}

.clone-text {
    color: #28a745;
    font-size: 16px;
    font-weight: 500;
}
</style>
